import { ca } from '@cian/analytics';
import { EPeriod, ERoomsCount } from '../../../repositories/valuation-offer-history/v1/get-market-trand';

export function trackOnTitleTooltipOpen() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Show_sopr',
    label: 'NearbyHousesInfo',
  });
}

export function trackRoomsFilterChange(rooms: ERoomsCount) {
  const roomsMapper = {
    [ERoomsCount.All]: 'all',
    [ERoomsCount.Studio]: 'studio',
    [ERoomsCount.OneRoom]: '1',
    [ERoomsCount.TwoRooms]: '2',
    [ERoomsCount.ThreeRooms]: '3',
    [ERoomsCount.FourPlusRooms]: '4+',
  };
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click',
    label: `PriceDynamic_${roomsMapper[rooms]}`,
  });
}

export function trackPeriodFilterChange(period: EPeriod) {
  const periodMapper = {
    [EPeriod.All]: 'all',
    [EPeriod.OneYear]: 'year',
    [EPeriod.OneMonth]: 'month',
    [EPeriod.TwoYears]: 'two_years',
    [EPeriod.SixMonths]: 'half_year',
  };

  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click',
    label: `PeriodDynamic_${periodMapper[period]}`,
  });
}
